<template>
  <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
    <div style="width:100%;">
      <QueryContainer @search="handleSearch" @reset="handleReset">
        <template v-slot:searchContent>
          <BlindSearchForm v-model="searchQuery"></BlindSearchForm>
        </template>
        <div slot="listContent">
          <h1 class="page_title">盲订订单</h1>
          <!-- 列表 -->
          <div class="page-list">
            <el-table :data="tableList" stripe v-loading="listLoading">
              <template v-for="column in tableColumns">
                <el-table-column :prop="column.props" :align="column.align || 'left'" :label="column.label"
                  :width="column.width" :min-width="column.minWidth" :fixed="column.fixed">
                  <template slot-scope="{row}">
                    <slot :name="column.props" :row="row">
                      <div v-if="column.props === 'customerName'" @click.stop.prevent="toDetailPage(row)"
                        style="color: #409EFF; cursor: pointer;">
                        {{ row.customerName || '' }}
                      </div>
                      <div v-else-if="column.props === 'customerPhone'">
                        <Desensitize
                          :text="row.customerPhone"
                          :userType="5"
                          :clearText="true"
                          :queryKey="row.id"
                          :key="row.id"
                        />
                      </div>
                      <div v-else>
                        {{ formatterColumnData(row, column) }}
                      </div>
                    </slot>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="page-pagination">
            <el-pagination background layout="total, sizes, prev, pager, next" :total="total"
              :page-sizes="[10, 20, 30, 50]" :page-size="searchQuery.limit" :current-page="searchQuery.page"
              @size-change="handleSizeChange" @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </QueryContainer>
    </div>
  </div>
</template>

<script>
import { refundStatusMap, blindOrderStatusMap, datePickerOption } from './constants.js'
import BlindSearchForm from './components/BlindSearchForm.vue'
import Desensitize from "@/components/Desensitize/Desensitize.vue";
var order_vm;

const columns = Object.freeze([
  { props: 'createdTime', label: '创建时间', minWidth: 135 },
  { props: 'customerName', label: '订车人姓名' },
  { props: 'customerPhone', label: '订车人电话', minWidth: 100 },
  { props: 'orderStatus', label: '订单状态', formatter: (row, props) => blindOrderStatusMap.get(row[props]), width: 80 },
  { props: 'ownerName', label: '客户经理', width: 80 },
  { props: 'seriesName', label: '盲订车系名称', minWidth: 100 },
  { props: 'IntentionMoney', label: '意向金' },
  { props: 'PaymentMoney', label: '订金' },
  { props: 'AppBlindOrderId', label: 'APP盲订订单号', minWidth: 95 },
  { props: 'appOrderId', label: 'APP订单号', minWidth: 100 },
  { props: 'refundStatus', label: '退款状态', formatter: (row, props) => refundStatusMap.get(row[props]), width: 70 },
  { props: 'refundTime', label: '退款时间', minWidth: 135 },
])

export default {
  components: {
    BlindSearchForm,
    Desensitize
  },
  data() {
    order_vm = this;
    return {
      refundStatusMap,
      blindOrderStatusMap,
      datePickerOption,
      listLoading: false,
      dealer: this.$common.getLoginInfo().profile,
      searchQuery: {
        page: 1,
        limit: 10,
        key: "", // 姓名或手机号
        dateRange1: null, // 创建时间
        blindOrderStatus: [], // 订单状态
        member: [], // 客户经理
        refundStatus: [], // 退订状态
      },
      tableList: [],
      tableColumns: columns,
      total: 0,
      members: [],
      routerOrderId: null
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let form = from.path;
      if (
        form === "/order/blindOrderDetail"
      ) {
        try {
          const listFilters = JSON.parse(sessionStorage.getItem("blindOrderDetail"));
          vm.searchQuery = listFilters.searchQuery;
          vm.total = listFilters.total;
        } catch (error) {
          console.log(error)
        }
      }
      vm.getList();
    });
  },
  mounted() { },
  methods: {
    formatterColumnData(row, column) {
      if (typeof column.formatter ===  'function') {
        return column.formatter(row, column.props)
      }
      if (row[column.props] === -9999.99){
        return '--'
      }
      return row[column.props]
    },
    handleSearch() {
      this.searchQuery.page = 1;
      this.getList();
    },
    // 重置
    handleReset() {
      this.searchQuery = {
        page: 1,
        limit: this.searchQuery.limit,
        key: "", // 姓名或手机号
        dateRange1: null, // 创建时间
        blindOrderStatus: [], // 订单状态
        member: [], // 客户经理
        refundStatus: [], // 退订状态
      };
      this.handleSearch();
    },
    // 获取列表数据
    getList() {
      const { page, limit, key, dateRange1, blindOrderStatus, member, refundStatus } = this.searchQuery
      let params = {
        pageStart: (page - 1) * limit,
        pageCount: limit,
        dealerId: this.dealer.dealerId,
        key, // 姓名或手机号
        createdDate: { // 创建时间
          start: dateRange1 != null ? dateRange1[0] : "",
          end: dateRange1 != null ? dateRange1[1] : "",
        },
        blindOrderStatus: blindOrderStatus.toString(), // 订单状态
        saleIds: member.length > 0 ? member.join(",") : "", // 客户经理
        refundStatus: refundStatus.toString(), // 退订状态
      };
      this.listLoading = true;
      this.$httpAuth
        .post("/v2/appCustomerService/blindOrders", params)
        .then((response) => {
          const { data = [], total = 0 } = response.data || {}
          this.tableList = data;
          this.total = total;
        })
        .catch(() => { })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleSizeChange(val) {
      this.searchQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchQuery.page = val;
      this.getList();
    },
    toDetailPage(item) {
      const listFilters = {
        searchQuery: this.searchQuery,
        total: this.total
      };
      sessionStorage.setItem("blindOrderDetail", JSON.stringify(listFilters));
      sessionStorage.setItem("form", "order");
      sessionStorage.setItem("type", null);
      this.$router.push({
        path: "/order/blindOrderDetail",
        query: { blingOrderId: item.id },
      });
    },
    // toCustomerDetail(row) {
    //   const listFilters = {
    //     searchQuery: this.searchQuery,
    //     total: this.total,
    //   };
    //   sessionStorage.setItem("type", null);
    //   sessionStorage.setItem("blindOrderDetail", JSON.stringify(listFilters));
    //   this.$router.push({
    //     path: "/customer/detail/" + row.customerId,
    //   });
    // }
  },
};
</script>

<style>
.page-list {
  padding: 10px 0;
}

.page-pagination {
  margin-top: 20px;
}
</style>
